import _ from "lodash";
import * as type from "./types";
export default (state = {}, action) => {
  switch (action.type) {
    case type.FETCH_NOTES:
      return { ..._.mapKeys(action.payload, "Id") };
    case type.FETCH_NOTE:
      return { ...state, [action.payload.Id]: action.payload };
    case type.CREATE_NOTE:
      return { ...state, [action.payload.Id]: action.payload };
    case type.EDIT_NOTE:
      return { ...state, [action.payload.Id]: action.payload };
    case type.READ_NOTE:
      return { ...state, [action.payload.Id]: action.payload };
    case type.DELETE_NOTE:
      return _.omit(state, action.payload);
    default:
      return state;
  }
};
